export default __webpack_public_path__ + "images/9facf2797d3e406da5f302a7fb300708.svg";